<template>

  <div id="app_content" class="admin admin_translations translations">

    <h1 class="mt-0">Traduzioni piattaforma</h1>

    <section class="header">


    </section>

    <p>Da questa sezione puoi gesitre le traduzioni delle entità presenti nel B2B.</p>

    <h3 class="mb-0">Entità</h3>

    <div class="search-elements">
      <div class="w-models">
        <v-select placeholder=" Cerca"
                  :options="getModelsTrans" :closeOnSelect="true"
                    :reduce="option => option.value"
                  v-model="model_type">
        </v-select>
      </div>

      <div class="filter-elements">
        <label class="w-100 block">Filtra per codice</label>
        <input type="text" v-model="query" placeholder="Codice" name="query">
      </div>
    </div>



    <section class="elements admin-section trans" :class="{v_loading: loading}">

      <div class="filter-elements" v-show="false">

        <label class="w-100 block">Filtra Aggiornamneti</label>
        <input type="text" v-model="query" placeholder="parola chiave" name="query">

      </div>

      <ul v-if="translations && transKeyModel.length > 0 && Object.keys(translationSearch).length" class="elements-list">

        <template v-if="true">
          <li v-for="(transModel, i) in translationSearch" :key="i" class="single-trans">

            <trans-single :transModel="transModel"/>

          </li>
        </template>


      </ul>

      <p v-else class="empty">Nessun elemento trovato...</p>

    </section>




  </div>

</template>

<script>
import TransSingle from './trans-single'

export default{
  components: {TransSingle},

  props: {

  },

  data: function(){

    return {

      loading: false,

      query: '',
      model_type: null,
      translations: {}, // {model_id: [taduzioni, ...], ...}
      settings_lang: {},
    }

  },

  mounted: function(){

    // this.loadSettings();

  },


  computed: {

    translationSearch: function () {
      let transFiltered = {};
      if (this.query === '')
        return this.translations;

      // let query = this.query.toLowerCase().replace(' ', '');
      let query = this.query.toLowerCase();

      for ( let id in this.translations ) {
        let cs = this.translations[id][0].code_search.toLowerCase(); //.replace(' ', '');
        if (cs.indexOf(query) > -1) {
          transFiltered[id] = this.translations[id];
        }
      }
      return transFiltered;
    },

    transKeyModel:function(){
      return Object.keys(this.translations);
    },

    getTrans: function() {
      return this.trans.messages[this.trans.fallback + '.admin'];
    },

    getModelsTrans: function(){
      let models = this.getTrans.translations.models;
      let modelsArray = [];
      for (let key in models) {
        modelsArray.push({label: models[key], value: key});
      }
      return modelsArray;
    },



  },

  methods: {

    loadTranslations: function() {
      var vue = this;
      vue.loading = true;

      axios({
        method: "get",
        url: window.location.origin + '/data/translations',
        params: {
          model_type: vue.model_type,
        }
      })
      .then(res => {
        console.log( res );
        if( res.data.translations ) vue.translations = res.data.translations;
      })
      .catch(err => {

        console.log( err.response );

        vue.$store.commit('add_message', {
          type: 'error',
          message: 'Si è verificato un errore, impossibile caricare le traduzione richieste'
        });

      })
      .then(() =>{
        vue.loading = false;
      })
    },


    loadSettings: function() {
      var vue = this;
      vue.loading = true;

      axios({
        method: "get",
        url: window.location.origin + '/data/translations/settings',
        params: {

        }
      })
      .then(res => {
        console.log( res );
        if( res.data.settings ) vue.settings_lang = res.data.settings;
      })
      .catch(err => {

        console.log( err.response );

        vue.$store.commit('add_message', {
          type: 'error',
          message: 'Si è verificato un errore, impossibile caricare le impostazioni di traduzione'
        });

      })
      .then(() =>{
        vue.loading = false;
      })
    },


  },

  watch: {

    model_type: function () {
      if (this.model_type) {
        this.loadTranslations();
      }
    },

  }


}
</script>

<style scoped>

.admin-section.trans {
  padding: 1em;;
}
.w-models, .filter-elements {
  width: 100%;
  max-width: 500px;
}
* >>> .load-component {
  color: var(--blue);
  text-decoration: underline;
  cursor: pointer;
}
* >>> .action-component.red {
  text-decoration: underline;
  cursor: pointer;
  color: var(--red);
}
section.elements{
  margin-top: 2em;
}
ul.elements-list{
  margin: 0;
  padding: 0;
  list-style-type: none;
}
ul.elements-list li{
  padding: 1em 0;
  border-bottom: 1px solid black;
}
input[name="query"]{
  padding: 5px 10px;
  border: 1px solid gray;
  width: 100%;
  max-width: 500px;
}
ul.elements-list li.single-trans[data-index="0"]{
  background-color: var(--disabled) !important;
}
/* ul.elements-list li.single-trans:nth-child(2n+1) {
	background-color: var(--background-gray-2);
}
ul.elements-list li.single-trans:nth-child(2n) {
	background-color: white;
} */

</style>
